"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAirportTransferEitherDirection = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function isAirportTransferEitherDirection(direction) {
    if (direction === null || direction === undefined) {
        return false;
    }
    return direction === legacy_enums_1.AirportTransferDirection.FromAirport || direction === legacy_enums_1.AirportTransferDirection.ToAirport;
}
exports.isAirportTransferEitherDirection = isAirportTransferEitherDirection;
//# sourceMappingURL=is-airport-transfer-either-direction.js.map